module.exports = __webpack_public_path__ + "static/part-11-56e5de2c8009789795a87071b1067167.svg";